<template>
  <div class="ecm__transaction section__padding">
    <div class="ecm__transaction-items">
      <el-tabs :tab-position="'right'" v-model="activeName">
        <el-tab-pane label="All" name="first">
          <p class="ecm__transaction-items-title" v-if="orders.length > 0">Transactions</p>
          <Card
            v-for="order in orders" :key="order.id"
            :order="order"
          />
          <div class="ecm__transaction-blank" v-if="orders.length === 0">
            <img src="@/assets/images/blank.svg" alt="">
            <p>No orders yet</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Done" name="second">
          <p class="ecm__transaction-items-title" v-if="doneOrders.length > 0">Transactions</p>
          <Card
            v-for="order in doneOrders" :key="order.id"
            :order="order"
          />
          <div class="ecm__transaction-blank" v-if="doneOrders.length === 0">
            <img src="@/assets/images/blank.svg" alt="">
            <p>No orders yet</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Expire" name="third">
          <p class="ecm__transaction-items-title" v-if="expiredOrders.length > 0">Transactions</p>
          <Card
            v-for="order in expiredOrders" :key="order.id"
            :order="order"
          />
          <div class="ecm__transaction-blank" v-if="expiredOrders.length === 0">
            <img src="@/assets/images/blank.svg" alt="">
            <p>No orders yet</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Pending" name="forth">
          <p class="ecm__transaction-items-title" v-if="pendingOrders.length > 0">Transactions</p>
          <Card
            v-for="order in pendingOrders" :key="order.id"
            :order="order"
          />
          <div class="ecm__transaction-blank" v-if="pendingOrders.length === 0">
            <img src="@/assets/images/blank.svg" alt="">
            <p>No orders yet</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Card from '@/components/transactions/Card'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Transaction',
  components: {
    Card
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  mounted () {
    this.fetchOrders()
  },
  computed: {
    ...mapState({
      orders: state => state.order.orders
    }),
    ...mapGetters({
      doneOrders: 'order/getDoneOrders',
      pendingOrders: 'order/getPendingOrders',
      expiredOrders: 'order/getExpiredOrders'
    })
  },
  methods: {
    ...mapActions({
      fetchOrders: 'order/fetchOrders'
    })
  }
}
</script>

<style lang="scss" scoped>
.ecm__transaction {
  .ecm__transaction-items {
    .ecm__transaction-items-title {
      font-weight: 500;
      font-size: 20px;
      color: var(--color-blue);
      margin-bottom: 5px;
    }
    &::v-deep .el-tabs {
      .el-tabs__header {
        text-align: center;
        width: 250px;
        &.is-right {
          margin-left: 30px;
        }
        .el-tabs__nav-wrap {
          .el-tabs__nav-scroll {
            .el-tabs__nav {
              .el-tabs__active-bar {
                background: yellow;
              }
              .el-tabs__item {
                color: var(--color-blue-background);
                text-transform: uppercase;
                font-weight: 600;
                &.is-active {
                  background: var(--color-blue-background);
                  color: white;
                }
              }
            }
          }
        }
      }
      .el-tabs__content {
        .el-tab-pane {
          .ecm__transaction-blank {
            height: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img {
              width: 100px;
            }
            p {
              margin-top: 10px;
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }
      }
    }
  }
}
</style>
